var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"caregiver-behavior-container"},[_c('CaregiverBehaviorRating',{attrs:{"detail":_vm.dashboard}}),_c('CaregiverBehaviorTable',{attrs:{"caregiverId":_vm.caregiverId},on:{"getDashboard":_vm.getDashboard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }